function uniq(arr) {
    return Array.from(new Set(arr));
}

export { uniq };
